import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSelectedWebsiteSharedUid } from "../../../../../features/optifundDashboardSlice";
import OptifundDashboardMobileTabs from "./OptifundDashboardMobileComponents/OptifundDashboardMobileTabs";

interface OptifundDashboardMobileProps {
  userToken: any;
  websiteSharedUid: string;
}

export default function OptifundDashboardMobile({ userToken, websiteSharedUid }: OptifundDashboardMobileProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedWebsiteSharedUid(websiteSharedUid));
  }, [websiteSharedUid, dispatch]);

  return <OptifundDashboardMobileTabs userToken={userToken} websiteSharedUid={websiteSharedUid} />;
}
